const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimeline(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1346",
    d: "M892.945 130.751a1 1 0 0 1-.634-1.773l4.633-3.8v-5.427a1 1 0 0 1 2 0v5.9a1 1 0 0 1-.366.773l-5 4.1a.99.99 0 0 1-.633.227z",
    style: {
      fill: "current"
    },
    transform: "translate(-879.944 -106.751)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1347",
    d: "M897.944 139.751a15 15 0 1 1 15-15 15.017 15.017 0 0 1-15 15zm0-28a13 13 0 1 0 13 13 13.015 13.015 0 0 0-13-13z",
    style: {
      fill: "current"
    },
    transform: "translate(-879.944 -106.751)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline);
export default __webpack_public_path__ + "static/media/icon-timeline.7e9d4071e6988af9c033dd0bb4ae9b07.svg";
export { ForwardRef as ReactComponent };